import { mapActions, mapState } from 'vuex'
import * as ReturnCodesConstants from '../../../../../../constants/ReturnCodesConstants'
import * as RoleCodeConstants from '../../../../../../constants/RoleCodeConstants'
import * as DictionaryConstants from '../../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'
import { checkReturnInfo } from '../../../../../../common/utils/return-message-util'
import moment from 'moment'

export default {
  data () {
    return {
      activeName: 'first',
      // 会员是否存在未审核的卡券，如果有则不可用
      firstTabsAble: false,
      secondTabsAble: false,
      isEdit: false,
      basicInfoForm: {
        vehicleName: 'Q3'
      },
      basicInfoFormRules: {
        vehicleName: [
          { required: true, message: '请输入车型名称', trigger: 'blur' }
        ]
      },
      checkedCoupons: [],
      couponInfoForm: {
        applicationType: '',
        couponList: []
      },
      amount: 0,
      memberId: '',
      carId: '',
      carNumber: '',
      couponIds: [],
      // 审批动作id
      approvalActiveId: ''
    }
  },
  computed: {
    ...mapState('cardOperationModule', ['couponsInfo', 'pendingApprovalCoupons', 'outsideTheStoreApplicationTypeOptions']),
    formData () {
      return {}
    },
    couponsInfoTocouponInfoForm () {
      this.couponInfoForm.couponList = this.couponsInfo
      return this.couponInfoForm
    },
    approvalCoupons () {
      let pendingApprovalCoupons = []
      if (this.pendingApprovalCoupons.length !== 0) {
        this.approvalActiveId = this.pendingApprovalCoupons[0].id
        pendingApprovalCoupons = this.pendingApprovalCoupons[0]
      }
      return pendingApprovalCoupons
    }
  },
  methods: {
    ...mapActions('cardOperationModule', ['grantOfCouponByData', 'getCouponsInfo', 'getApprovalByMemberId', 'couponApproval',
      'getApplicationTypeOptions']),
    handleClick (tab, event) {
      // if (tab.name === 'second') {
      //   this.queryCouponApprovalByMemberId()
      // }
      this.queryCouponApprovalByMemberId()
    },
    editVehicleName () {
      this.$refs['basicInfoForm'].validate((valid) => {
        if (valid) {
          this.isEdit = !this.isEdit
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    expandDetail (index) {
      this.couponInfoForm.couponList[index].showRemarks = !this.couponInfoForm.couponList[index].showRemarks
    },
    // 计算合计金额
    computeAmount () {
      this.amount = 0
      this.couponInfoForm.couponList.forEach(item => {
        this.amount += Number(item.times) * Number(item.price)
      })
    },
    // 取消提交申请
    cancelApproval () {
      this.$router.push({
        path: RoutePathConstants.CARD_OPERATION_SEARCH
      })
    },
    // 提交卡券
    submitCoupon () {
      if (this.checkedCoupons.length === 0) {
        this.$message.warning('请选择一张卡券之后再提交申请')
        return
      }
      this.$refs['couponInfoForm'].validate(async (valid) => {
        if (valid) {
          let couponNumberDTOList = []
          this.checkedCoupons.forEach(it => {
            couponNumberDTOList.push({
              couponId: it.id,
              couponQty: it.times,
              couponPrice: it.price
            })
          })
          // 发放卡券data
          const data = {
            memberId: this.memberId,
            carId: this.carId,
            // applicationType: this.couponInfoForm.applicationType,
            applicationType: 2000,
            vehicleName: this.basicInfoForm.vehicleName,
            couponNumberDTOList: couponNumberDTOList
          }
          const result = await this.grantOfCouponByData(data)
          if (result.code !== ReturnCodesConstants.SUCCESS_CODE) return
          checkReturnInfo(result, '提交申请')
          // 将返回的审批动作id给全局变量
          this.approvalActiveId = result.data
          // 提交申请成功后查询以下待审核的卡券信息，然后跳转到审核tabs
          this.queryCouponApprovalByMemberId()
          this.activeName = 'second'
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 选择卡券的时候卡券id集合
    changeCouponIds () {
      this.couponIds = []
      this.checkedCoupons.forEach(item => this.couponIds.push(item.id))
    },
    // 查看卡券是否被选中，如果卡券id在checkbox的值中，则对对应的内容添加校验条件
    checkCouponId (id, index) {
      return this.couponIds.includes(id)
    },
    // 根据会员id查询发券动作（主要目的为了可以追溯已提交发券的申请）
    async queryCouponApprovalByMemberId () {
      const data = {
        releaseRole: RoleCodeConstants.OUT_WORKER,
        carId: this.carId,
        couponStatus: DictionaryConstants.COUPON_GIVE_OUT_NOT_PENDING
      }
      const result = await this.getApprovalByMemberId(data)
      if (result.length > 0) {
        this.activeName = 'second'
        this.firstTabsAble = true
        this.secondTabsAble = false
      } else {
        this.activeName = 'first'
        this.firstTabsAble = false
        this.secondTabsAble = true
      }
    },
    // 通过审批
    passApproval () {
      this.$confirm('审批通过', '通过', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        customClass: 'message-box'
      }).then(async () => {
        const data = {
          id: this.approvalActiveId,
          couponStatus: DictionaryConstants.PASSED,
          reasonForRejection: ''
        }
        const result = await this.couponApproval(data)
        checkReturnInfo(result, result.data)
        this.$router.push({
          path: RoutePathConstants.WX_PERSONAL_CENTER
        })
      }).catch(() => {
        console.log('取消通过')
      })
    },
    // 审批驳回
    rejectApproval () {
      this.$prompt('请输入驳回原因', '驳回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        customClass: 'message-box'
      }).then(async ({ value }) => {
        const data = {
          id: this.approvalActiveId,
          couponStatus: DictionaryConstants.TURN_DOWN,
          reasonForRejection: value
        }
        const result = await this.couponApproval(data)
        checkReturnInfo(result, result.data)
        this.$router.push({
          path: RoutePathConstants.WX_PERSONAL_CENTER
        })
      }).catch(() => {
        console.log('取消驳回')
      })
    },
    // 时间格式化
    dateFormate (time) {
      return time ? moment(time).format('YYYY-MM-DD') : '暂无'
    }
  },
  mounted () {
    // 查询购买类别
    // this.getApplicationTypeOptions(DictionaryConstants.OUTSIDE_THE_STORE_APPLICATION_TYPE)
    this.memberId = this.$route.query.memberId
    this.carId = this.$route.query.carId
    this.carNumber = this.$route.query.carNumber
    this.basicInfoForm.vehicleName = this.$route.query.vehicleName
    // 先判断一下改会员是否存在已发券未审批的情况，如果有，则不可以继续发放卡券，并直接跳转到卡券审核
    this.queryCouponApprovalByMemberId()
    // 查询可以发放的卡券
    // 多年合同保养卡 '1590738327374
    // 工时费代金券200元 1593496601546
    // 大用户转介绍200元保养代金券 9d7d49ed-b038-4651-9d12-6d0c1dfd668f
    // 大用户300元代金券 c30f69a9-18d5-48ba-863f-0d82ef3c7f85
    this.getCouponsInfo(['1590737684767', '1590381382631', '6410d799-2e70-4627-87ae-1d3c2da96ffc',
      'da26629f-6b00-4c2a-8ca2-fb749ae943a8', '1d8947f4-cd25-4a16-b593-de20905b938e',
      '4957f1c1-1530-41ff-814c-10ccde3c2259', '1590038309542', '216b4105-0372-4084-9e89-3c2183043694',
      '15ae9af3-a556-4cb1-921b-557a746fbb6f', '7a7d429e-c343-44e8-ba4e-621eb95a4bc5',
      'f185585f-f76e-40bf-bc07-d2af7e6045d8','bbfb1809-67d4-410b-b3ac-9a8726ed3171',
      '1ba0d23f-d945-4dad-b707-cb4c5f2ff2aa', '9881940f-d6b3-46fb-8834-a1dc49e0e03d', 'eb781799-a0bc-4629-8407-19293dd6348b',
      '92a5f2ae-d220-445a-81c5-894a62435a88'])
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/card-operation/views/components/grant-of-coupon.js